/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderItemBulkUpsertRequest } from '../models/OrderItemBulkUpsertRequest';
import type { OrderItemCreate } from '../models/OrderItemCreate';
import type { OrderItemResponse } from '../models/OrderItemResponse';
import type { OrderItemUpdate } from '../models/OrderItemUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderItemsService {
    /**
     * Create Order Item
     * @param orderId
     * @param requestBody
     * @returns OrderItemResponse Successful Response
     * @throws ApiError
     */
    public static createOrderItemOrdersOrderIdItemsPost(
        orderId: number,
        requestBody: OrderItemCreate,
    ): CancelablePromise<OrderItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/{order_id}/items',
            path: {
                'order_id': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin List Order Items
     * @param orderId
     * @returns OrderItemResponse Successful Response
     * @throws ApiError
     */
    public static adminListOrderItemsOrdersOrderIdItemsGet(
        orderId: number,
    ): CancelablePromise<Array<OrderItemResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{order_id}/items',
            path: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Upsert Order Items
     * @param orderId
     * @param requestBody
     * @returns OrderItemResponse Successful Response
     * @throws ApiError
     */
    public static bulkUpsertOrderItemsOrdersOrderIdItemsPut(
        orderId: number,
        requestBody: OrderItemBulkUpsertRequest,
    ): CancelablePromise<Array<OrderItemResponse>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/{order_id}/items',
            path: {
                'order_id': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get My Order Item
     * @param orderId
     * @param itemId
     * @returns OrderItemResponse Successful Response
     * @throws ApiError
     */
    public static getMyOrderItemOrdersOrderIdItemsItemIdGet(
        orderId: number,
        itemId: number,
    ): CancelablePromise<OrderItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{order_id}/items/{item_id}',
            path: {
                'order_id': orderId,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Update Order Item
     * @param orderId
     * @param itemId
     * @param requestBody
     * @returns OrderItemResponse Successful Response
     * @throws ApiError
     */
    public static adminUpdateOrderItemOrdersOrderIdItemsItemIdPut(
        orderId: number,
        itemId: number,
        requestBody: OrderItemUpdate,
    ): CancelablePromise<OrderItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/{order_id}/items/{item_id}',
            path: {
                'order_id': orderId,
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Delete Order Item
     * @param orderId
     * @param itemId
     * @returns void
     * @throws ApiError
     */
    public static adminDeleteOrderItemOrdersOrderIdItemsItemIdDelete(
        orderId: number,
        itemId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/orders/{order_id}/items/{item_id}',
            path: {
                'order_id': orderId,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
